<template>
  <div class="page-table">
    <div class="page-search">
      <a-form :form="searchForm" @submit="handleSearch">
        <a-row>
          <a-col :span="7">
            <a-form-item label="报修日期" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-range-picker style="width:100%;" @change="onpickerChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item label="校区" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-select
                allowClear
                :options="cityOptions"
                placeholder="全部校区"
                v-decorator="['schoolCode',
              {
                rules:[
                  { required: false,message: '请选择校区！'}
                ]
              }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" class="search-btns">
            <a-button style="margin-right:20px;" type="primary" html-type="submit">统计</a-button>
            <a-button type="primary" @click="exportExcel">导出</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-row class="thistopnav">
      <div class="table-operator">
        <div id="staseChart" :style="{width: '100%', height: '400px'}"></div>
      </div>
      <div class="table-operator">
        <div id="typeChart" :style="{width: '100%', height: '400px'}"></div>
      </div>
    </a-row>
    <a-row class="thistopnav">
      <div class="table-operator">
        <div id="personChart" :style="{width: '100%', height: '400px'}"></div>
      </div>
      <div class="table-operator">
        <div id="myChart" :style="{width: '100%', height: '400px'}"></div>
      </div>
    </a-row>
  </div>
</template>

<script>
const env = process.env.NODE_ENV
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
export default {
  name: 'QueryList',
  data () {
    return {
      searchForm: this.$form.createForm(this),
      selectedRows: [],
      current: {},
      startTime: '',
      endTime: '',
      pieoneData: {},
      pietwoData: {},
      piethirData: {},
      lineData: {},
      cityOptions: []
    }
  },
  mounted () {
    // 订单状态统计
    this.fetchList(this.getParams())
    // 报修类型统计
    this.bxlxtj(this.getParams())
    // 报修人类型统计
    this.bxrlxtj(this.getParams())
    // 维修人员单数统计
    this.wxrydstj(this.getParams())
    // 获取学区下拉
    this.schoolArea()
  },
  methods: {
    // 订单状态统计
    fetchList (params) {
      this.$axios.post('/api/xtfx/ddzttj.do', params).then(res => {
        var maindata = []
        for (var i = 0; i < res.data.list.labels.length; i++) {
          maindata.push({
          name: res.data.list.labels[i],
          value: res.data.list.colValues[0][i]
          })
        }
        this.pieoneData = {
          text: res.data.list.labels,
          data: maindata,
          value: res.data.list.colValues[0]
        }
        this.$nextTick(function(){
          this.drawpie()
        })
      })
    },
    drawpie () {
      let labels = {
        position: 'inside',
        formatter: '{b}({c})'
      }
      for (var i = 0; i < this.pieoneData.data.length; i++) {
        this.pieoneData.data[i].label = labels
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('staseChart'))
      // 绘制图表
      myChart.setOption({
        color: [
          '#4472c4',
          '#ed7d31',
          '#a5a5a5',
          '#ffc000',
          '#5b9bd5',
          '#70ad47',
          '#264478',
          '#d33200',
          '#5252c1'
        ],
        title: {
          text: '报修单状态统计',
          left: 'center',
          textStyle: {
            fontSize: 16,
            lineHeight: 56
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 10,
          left: 'center',
          data: this.pieoneData.text
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: this.pieoneData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    // 报修类型统计
    bxlxtj (params) {
      this.$axios.post('/api/xtfx/bxlxtj.do', params).then(res => {
        var maindata = []
        for (var i = 0; i < res.data.list.labels.length; i++) {
          maindata.push({
          name: res.data.list.labels[i],
          value: res.data.list.colValues[0][i]
          })
        }
        this.pietwoData = {
          text: res.data.list.labels,
          data: maindata,
          value: res.data.list.colValues[0]
        }
        this.$nextTick(function(){
          this.drawpietwo()
        })
      })
    },
    drawpietwo () {
      let labels = {
        position: 'inside',
        formatter: '{b}({c})'
      }
      for (var i = 0; i < this.pietwoData.data.length; i++) {
        this.pietwoData.data[i].label = labels
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('typeChart'))
      // 绘制图表
      myChart.setOption({
        color: [
          '#4472c4',
          '#ed7d31',
          '#a5a5a5',
          '#ffc000',
          '#5b9bd5',
          '#70ad47',
          '#264478',
          '#d33200',
          '#5252c1'
        ],
        title: {
          text: '报修类型统计',
          left: 'center',
          textStyle: {
            fontSize: 16,
            lineHeight: 56
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 10,
          left: 'center',
          data: this.pietwoData.text
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: this.pietwoData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    // 报修人类型统计
    bxrlxtj (params) {
      this.$axios.post('/api/xtfx/bxrlxtj.do', params).then(res => {
        var maindata = []
        for (var i = 0; i < res.data.list.labels.length; i++) {
          maindata.push({
          name: res.data.list.labels[i],
          value: res.data.list.colValues[0][i]
          })
        }
        this.piethirData = {
          text: res.data.list.labels,
          data: maindata,
          value: res.data.list.colValues[0]
        }
        this.$nextTick(function(){
          this.drawpiethir()
        })
      })
    },
    drawpiethir () {
      let labels = {
        position: 'inside',
        formatter: '{b}({c})'
      }
      for (var i = 0; i < this.piethirData.data.length; i++) {
        this.piethirData.data[i].label = labels
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('personChart'))
      // 绘制图表
      myChart.setOption({
        color: [
          '#4472c4',
          '#ed7d31',
          '#a5a5a5',
          '#ffc000',
          '#5b9bd5',
          '#70ad47',
          '#264478',
          '#d33200',
          '#5252c1'
        ],
        title: {
          text: '报修人类型统计',
          left: 'center',
          textStyle: {
            fontSize: 16,
            lineHeight: 56
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 10,
          left: 'center',
          data: this.piethirData.text
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: this.piethirData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    // 维修人员单数统计
    wxrydstj (params) {
      this.$axios.post('/api/xtfx/wxrydstj.do', params).then(res => {
        var maindata = []
        for (var i = 0; i < res.data.list.labels.length; i++) {
          maindata.push({
          name: res.data.list.labels[i],
          value: res.data.list.colValues[0][i]
          })
        }
        this.lineData = {
          text: res.data.list.labels,
          data: maindata,
          value: res.data.list.colValues[0]
        }
        this.$nextTick(function(){
          this.drawLine()
        })
      })
    },
    drawLine () {
      let labels = {
        show: true,
        position: 'top'
      }
      let newdata = []
      let datazoom = []
      if (this.lineData.value.length > 20) {
        datazoom = [
          {
            show: true,
            start: 1,
            end: 50
          }
        ]
      }
      for (var i = 0; i < this.lineData.value.length; i++) {
        newdata.push({
          label: labels,
          value: this.lineData.value[i],
          name: this.lineData.text[i]
        })
      }
      this.lineData.value = newdata
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        color: ['#3398DB'],
        title: {
          text: '维修人员单数统计',
          left: 'center',
          textStyle: {
            fontSize: 16,
            lineHeight: 56
          }
        },
        grid: {
          bottom: 80
        },
        legend: {
          bottom: 5,
          left: 'center',
          data: ['订单数']
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}'
        },
        xAxis: {
          data: this.lineData.text,
          axisLabel: {
            rotate: 35
          }
        },
        yAxis: { type: 'value' },
        dataZoom: datazoom,
        series: [
          {
            name: '订单数',
            type: 'bar',
            data: this.lineData.value
            // barWidth: '10',
            // barGap: '50%'
          }
        ]
      })
    },
    // 获取学区下拉
    schoolArea () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.cityOptions = res.data.data || []
      })
    },
    // 获取时间
    onpickerChange (date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
    },
    // 导出excel
    exportExcel (e) {
      e.preventDefault()
      let url = env === 'production'
          ? '/xtfx/exportOrder.do'
          : '/api/xtfx/exportOrder.do'
      this.epxportway(url, this.getParams())
    },
    // 导出方法
    epxportway (url, data) {
      if (url && data) {
        var form = window.$('<form></form>')
        form.attr('action', url)
        form.attr('method', 'post')
        for (var item in data) {
          var input = window.$('<input type="text"/>')
          input.attr('name', item)
          input.attr('value', data[item])
          form.append(input)
        }
        form.appendTo('body').submit().remove()
      }
    },
    // 搜索
    handleSearch (e) {
      e.preventDefault()
      this.fetchList(this.getParams())
      // 报修类型统计
      this.bxlxtj(this.getParams())
      // 报修人类型统计
      this.bxrlxtj(this.getParams())
      // 维修人员单数统计
      this.wxrydstj(this.getParams())
    },
    onRowChange (selectedRows) {
      console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getParams (custParam) {
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...custParam,
        startTime: this.startTime,
        endTime: this.endTime,
        type: 1
      }
      return params
    }
  }
}
</script>
<style lang="less">
.thistopnav {
    .table-operator {
        display: inline-block;
        width: 49.5%;
        margin-right: 5px;
        vertical-align: top;
        min-height: 354px;
        border-radius: 3px;
        margin-bottom: 10px;
        .ant-row {
            font-size: 14spx;
            height: 34px;
            line-height: 44px;
            text-align: left;
        }
    }
    .table-operator:last-child {
        margin-left: 5px;
        margin-right: 0;
    }
}
</style>
